import { FC } from 'react';

import TooltipConflictRow from '@/apps/mwd-v2/components/MwdTooltip/parts/TooltipConflictRow';
import { timeComparator } from '@/apps/mwd-v2/utils/timeComparator';
import { Conflict } from '@/types/Conflicten';
import { geefTijdstipVoorConflict } from '@/views/ddp/utils/conflict';

import TooltipListTitle from './TooltipListTitle';

type TooltipVeiligheidsConflictenProps = {
  conflicten: Conflict[];
};
const TooltipVeiligheidsConflicten: FC<TooltipVeiligheidsConflictenProps> = ({ conflicten }) => {
  conflicten.sort((a, b) => timeComparator(a, b, geefTijdstipVoorConflict));
  return (
    <>
      {conflicten?.length > 0 && (
        <div>
          <div
            style={{
              borderTop: '1px solid var(--tractie-color-border-default-inverse)',
              marginTop: '6px',
              paddingTop: '6px',
            }}
          >
            <TooltipListTitle data-testid='conflicten' title='Veiligheidsconflicten' />
            {conflicten.map((conflict) => (
              <div key={conflict.conflictId} style={{ display: 'flex' }}>
                <TooltipConflictRow conflict={conflict} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
export default TooltipVeiligheidsConflicten;
